{
	"dismissButton": "Dismiss",
	"upgradeDescriptionLinux": "Update with your package manager, for example run \"sudo apt update && sudo apt install google-chrome-stable\", then restart Chrome.",
	"upgradeDescriptionMac": "Open the Chrome menu > Help > About Google Chrome to check for updates, then relaunch the browser.",
	"upgradeDescriptionWindows": "Open the Chrome menu (three dots) > Help > About Google Chrome. Updates install automatically; relaunch when prompted.",
	"upgradeTitleLinux": "Linux",
	"upgradeTitleMac": "Chrome",
	"upgradeTitleWindows": "Windows",
	"updateChromeMessage": "You're running Chrome {{version}}. Some features may run slower or be unstable on this build. We recommend updating to version {{minimumVersion}} or newer for the best experience.",
	"updateChromeTitle": "Update Chrome for best performance"
}
